<template>
  <div style="margin: 0">
    <div class="logo-outer">
      <div class="logo">
        <v-img :aspect-ratio="1" src="@/assets/logo.svg" cover></v-img>
      </div>
    </div>
    <v-container class="main-item">
      <v-card class="mx-auto card-width">
        <v-card-text class="card-header">
          <div class="headerText">{{ firstTitle }}</div>

          <div class="headInfo">
            {{ goodsType }}{{ intendedForWhom }}{{ personalLevel }}
            {{ usedSubscription }}
            <br />
            {{ fullName }} / {{ x.email }} / {{ x.phone }}
          </div>
        </v-card-text>
        <v-divider></v-divider>

        <v-window v-model="step">
          <v-window-item :value="1">
            <v-card-actions class="main-btn-area">
              <v-container
                class="d-flex flex-column flex-md-row justify-space-around"
              >
                <v-btn
                  :disabled="!allApproval"
                  class="btn my-3"
                  @click="
                    x.isAbonement = true;
                    step++;
                  "
                >
                  <template v-slot:default>
                    <div
                      class="d-flex flex-column flex-sm-row flex-md-column flex-lg-row"
                    >
                      <div>Я ХОЧУ КУПИТЬ</div>
                      <div style="margin-left: 0.2rem">АБОНЕМЕНТ</div>
                    </div>
                  </template>
                </v-btn>
                <v-btn
                  class="btn my-3"
                  @click="
                    x.isAbonement = false;
                    step++;
                  "
                  :disabled="!allApproval"
                >
                  <template v-slot:default>
                    <div
                      class="d-flex flex-column flex-sm-row flex-md-column flex-lg-row"
                    >
                      <div>Я ХОЧУ КУПИТЬ</div>
                      <div style="margin-left: 0.2rem">СЕРТИФИКАТ</div>
                    </div>
                  </template>
                </v-btn>
              </v-container>
            </v-card-actions>

            <v-container class="px-md-10 px-2">
              <v-checkbox
                v-model="agreeOffer"
                dense
                :label="'Я согласен/а с условиями оферты и понимаю, что купленный абонемент возврату и обмену не подлежит'"
              >
              </v-checkbox>

              <v-checkbox
                v-model="agreeExpiration"
                dense
                :label="'Я ознакомлен со сроками активации абонементов (14 дней) и сертификатов (6 месяцев)'"
              >
              </v-checkbox>

              <v-checkbox
                v-model="agreeProcessingPersonalData"
                dense
                :label="'Даю согласие на обработку персональных данных'"
              >
              </v-checkbox>
            </v-container>
          </v-window-item>

          <v-window-item :value="2">
            <v-card-actions class="main-btn-area">
              <v-container
                class="d-flex flex-column flex-md-row justify-space-around"
              >
                <v-btn
                  class="btn my-3"
                  @click="
                    info.hooseForOther = false;
                    step++;
                  "
                >
                  <template v-slot:default>
                    <div
                      class="d-flex flex-column flex-sm-row flex-md-column flex-lg-row"
                    >
                      <div>ПОКУПАЮ</div>
                      <div style="margin-left: 0.2rem">ДЛЯ СЕБЯ</div>
                    </div>
                  </template>
                </v-btn>
                <v-btn
                  class="btn my-3"
                  @click="
                    x.forAnother = true;
                    step++;
                  "
                >
                  <template v-slot:default>
                    <div
                      class="d-flex flex-column flex-sm-row flex-md-column flex-lg-row"
                    >
                      <div>ПОКУПАЮ</div>
                      <div style="margin-left: 0.2rem">ДЛЯ ДРУГОГО</div>
                    </div>
                  </template>
                </v-btn>
              </v-container>
            </v-card-actions>
          </v-window-item>

          <v-window-item :value="3">
            <v-card-actions class="main-btn-area third-step">
              <div
                class="d-flex flex-column flex-lg-row justify-space-around w-100"
              >
                <v-btn
                  class="btn my-3 third-step"
                  @click="
                    x.isNovice = false;
                    step++;
                  "
                >
                  <span v-html="msgFullTimeLesson"></span>
                </v-btn>
                <v-btn
                  class="btn my-3 third-step"
                  @click="
                    x.isNovice = true;
                    step++;
                  "
                >
                  <span v-html="msgNewAtLesson"></span>
                </v-btn>
              </div>
            </v-card-actions>
          </v-window-item>

          <v-window-item :value="4">
            <template v-if="isForm1">
              <FormType1
                v-bind:info="info"
                v-bind:last-name="x.lastname"
                v-bind:first-name="x.firstname"
                v-bind:middle-name="x.middlename"
                v-bind:email="x.email"
                v-bind:phone="x.phone"
                v-bind:ihavecertificat="x.ihavecertificat"
                v-bind:mychoise="x.mychoise"
                v-bind:custom-abonement="x.customAbonement"
                v-bind:userinfo="x.info"
                v-bind:mycertificat="x.mycertificat"
                v-bind:isAbonement="x.isAbonement"
                @updateLastName="(v) => (this.x.lastname = v)"
                @updateFirstName="(v) => (this.x.firstname = v)"
                @updateMiddleName="(v) => (this.x.middlename = v)"
                @updateEmail="(v) => (this.x.email = v)"
                @updatePhone="(v) => (this.x.phone = v)"
                @updateMychoise="(v) => (this.x.mychoise = v)"
                @updateCustomAbonement="(v) => (this.x.customAbonement = v)"
                @updateIhavecertificat="(v) => (this.x.ihavecertificat = v)"
                @updateMycertificat="(v) => (this.x.mycertificat = v)"
                @updateValid="(v) => (this.valid = v)"
              />
            </template>

            <template v-if="isForm2">
              <FormType2
                v-bind:info="info"
                v-bind:last-name="x.lastname"
                v-bind:first-name="x.firstname"
                v-bind:middle-name="x.middlename"
                v-bind:email="x.email"
                v-bind:phone="x.phone"
                v-bind:birthday="x.birthday"
                v-bind:mychoise="x.mychoise"
                v-bind:custom-abonement="x.customAbonement"
                v-bind:description="x.description"
                v-bind:isAbonement="x.isAbonement"
                @updateLastName="(v) => (this.x.lastname = v)"
                @updateFirstName="(v) => (this.x.firstname = v)"
                @updateMiddleName="(v) => (this.x.middlename = v)"
                @updateEmail="(v) => (this.x.email = v)"
                @updatePhone="(v) => (this.x.phone = v)"
                @updateDescription="(v) => (this.x.description = v)"
                @updateBirthday="(v) => (this.x.birthday = v)"
                @updateMychoise="(v) => (this.x.mychoise = v)"
                @updateCustomAbonement="(v) => (this.x.customAbonement = v)"
                @updateValid="(v) => (this.valid = v)"
              />
            </template>

            <template v-if="isForm3">
              <FormType3
                v-bind:info="info"
                v-bind:last-name="x.lastname"
                v-bind:first-name="x.firstname"
                v-bind:middle-name="x.middlename"
                v-bind:broker-last-name="x.brokerlastname"
                v-bind:broker-first-name="x.brokerfirstname"
                v-bind:broker-middle-name="x.brokermiddlename"
                v-bind:broker-email="x.brokeremail"
                v-bind:broker-phone="x.brokerphone"
                v-bind:mychoise="x.mychoise"
                v-bind:custom-abonement="x.customAbonement"
                v-bind:isAbonement="x.isAbonement"
                @updateLastName="(v) => (this.x.lastname = v)"
                @updateFirstName="(v) => (this.x.firstname = v)"
                @updateMiddleName="(v) => (this.x.middlename = v)"
                @updateBrokerLastName="(v) => (this.x.brokerlastname = v)"
                @updateBrokerFirstName="(v) => (this.x.brokerfirstname = v)"
                @updateBrokerMiddleName="(v) => (this.x.brokermiddlename = v)"
                @updateBrokerEmail="(v) => (this.x.brokeremail = v)"
                @updateBrokerPhone="(v) => (this.x.brokerphone = v)"
                @updateMychoise="(v) => (this.x.mychoise = v)"
                @updateCustomAbonement="(v) => (this.x.customAbonement = v)"
                @updateValid="(v) => (this.valid = v)"
              />
            </template>

            <template v-if="isForm4">
              <FormType4
                v-bind:info="info"
                v-bind:last-name="x.lastname"
                v-bind:first-name="x.firstname"
                v-bind:middle-name="x.middlename"
                v-bind:email="x.email"
                v-bind:phone="x.phone"
                v-bind:birthday="x.birthday"
                v-bind:mychoise="x.mychoise"
                v-bind:custom-abonement="x.customAbonement"
                v-bind:description="x.description"
                v-bind:broker-last-name="x.brokerlastname"
                v-bind:broker-first-name="x.brokerfirstname"
                v-bind:broker-middle-name="x.brokermiddlename"
                v-bind:broker-email="x.brokeremail"
                v-bind:broker-phone="x.brokerphone"
                v-bind:isAbonement="x.isAbonement"
                @updateLastName="(v) => (this.x.lastname = v)"
                @updateFirstName="(v) => (this.x.firstname = v)"
                @updateMiddleName="(v) => (this.x.middlename = v)"
                @updateEmail="(v) => (this.x.email = v)"
                @updatePhone="(v) => (this.x.phone = v)"
                @updateDescription="(v) => (this.x.description = v)"
                @updateBirthday="(v) => (this.x.birthday = v)"
                @updateMychoise="(v) => (this.x.mychoise = v)"
                @updateCustomAbonement="(v) => (this.x.customAbonement = v)"
                @updateBrokerLastName="(v) => (this.x.brokerlastname = v)"
                @updateBrokerFirstName="(v) => (this.x.brokerfirstname = v)"
                @updateBrokerMiddleName="(v) => (this.x.brokermiddlename = v)"
                @updateBrokerEmail="(v) => (this.x.brokeremail = v)"
                @updateBrokerPhone="(v) => (this.x.brokerphone = v)"
                @updateValid="(v) => (this.valid = v)"
              />
            </template>

            <v-divider></v-divider>
          </v-window-item>
          <v-window-item :value="5">
            <v-container
              class="d-flex flex-column flex-md-row justify-space-around mt-10"
            >
              <template v-if="inProgress">
                <div class="d-flex flex-column justify-center mx-auto">
                  <v-progress-circular
                    :size="70"
                    :width="5"
                    color="amber"
                    indeterminate
                  ></v-progress-circular>
                </div>
              </template>
              <template v-if="requestCompleted">
                <div class="d-flex flex-column justify-center mx-auto">
                  <v-icon v-if="result.ok" class="ok-icon"
                    >mdi-check-circle</v-icon
                  >
                  <v-icon v-if="!result.ok" class="error-icon"
                    >mdi-alert-circle-outline</v-icon
                  >
                  <div>{{ result.message }}</div>
                </div>
              </template>
            </v-container>
          </v-window-item>
        </v-window>

        <v-card-actions class="nav-btn-area">
          <v-container>
            <div
              class="d-flex flex-column flex-sm-row justify-space-around align-center w-100"
            >
              <v-btn
                v-if="step > 1"
                class="btn my-2"
                @click="goBack()"
                :disabled="inProgress"
              >
                <v-icon left>mdi-reply</v-icon>
                НАЗАД
              </v-btn>
              <v-btn
                v-if="step === 4"
                class="btn send my-2"
                :disabled="!valid"
                @click="sendorder"
              >
                ОТПРАВИТЬ
                <v-icon right>mdi-send</v-icon>
              </v-btn>
              <v-btn
                v-if="step === 5"
                class="btn my-2"
                :disabled="inProgress"
                @click="goStart()"
              >
                <v-icon left>mdi-home</v-icon>
                НА ГЛАВНУЮ
              </v-btn>
            </div>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";

import FormType1 from "@/components/FormType1";
import FormType2 from "@/components/FormType2";
import FormType3 from "@/components/FormType3";
import FormType4 from "@/components/FormType4";

import "@/components/MainView.scss";

export default {
  name: "MainView",
  data: () => ({
    step: 1,
    firstTitle:
      "Чтобы купить абонемент или подарочный сертификат онлайн, пожалуйста, заполните данные ниже и отправьте заявку," +
      " а мы пришлем Вам ссылку для оплаты картой.",
    iamagree: false,

    valid: false,

    agreeOffer: false,
    agreeExpiration: false,
    agreeProcessingPersonalData: false,

    x: {
      firstname: "",
      middlename: "",
      lastname: "",
      email: "",
      phone: "",
      birthday: "",
      description: "",

      ihavecertificat: false,
      mycertificat: "",

      mychoise: null,
      customAbonement: "",

      brokerfirstname: "",
      brokerlastname: "",
      brokermiddlename: "",
      brokeremail: "",
      brokerphone: "",

      forAnother: false,
      isNovice: false,
      isAbonement: true,
    },

    info: {
      nameRules: [
        (v) => !!v || "Поле необходимо заполнить",
        (v) => v.length <= 40 || "Поле не должно превышать 40 символов",
      ],
      emailRules: [
        (v) => !!v || "Необходимо заполнить E-mail",
        (v) =>
          (v.length <= 40 && /.+@.+/.test(v)) || "Неопознанный формат E-mail",
      ],
      phoneRules: [
        (v) => !!v || "Необходимо ввести номер телефона",
        (v) =>
          /^[+]?\d{4}-?\d{3}-?\d{2}-?\d{2}$/.test(v) ||
          "Неопознанный номер телефона",
      ],

      abonements: [
        { title: "СТАНДАРТНЫЙ, 4 ЗАНЯТИЯ" },
        { title: "СТАНДАРТНЫЙ, 8 ЗАНЯТИЙ" },
        { title: "СТАНДАРТНЫЙ, 12 ЗАНЯТИЙ" },
        { title: "ДНЕВНОЙ, 4 ЗАНЯТИЯ" },
        { title: "ДНЕВНОЙ, 8 ЗАНЯТИЙ" },
        { title: "ДНЕВНОЙ, 12 ЗАНЯТИЙ" },
        { title: "БЕЗЛИМИТНЫЙ, 3 МЕСЯЦА" },
        { title: "БЕЗЛИМИТНЫЙ, 6 МЕСЯЦЕВ" },
        { title: "ДРУГОЕ" },
      ],

      certificates: [
        { title: "СТАНДАРТНЫЙ, 4 ЗАНЯТИЯ" },
        { title: "СТАНДАРТНЫЙ, 8 ЗАНЯТИЙ" },
        { title: "СТАНДАРТНЫЙ, 12 ЗАНЯТИЙ" },
        { title: "БЕЗЛИМИТНЫЙ, 3 МЕСЯЦА" },
        { title: "БЕЗЛИМИТНЫЙ, 6 МЕСЯЦЕВ" },
        { title: "ДРУГОЕ" },
      ],
    },
    requestCompleted: false,
    result: {
      ok: false,
      message: "",
    },
    inProgress: false,
    duration: 500,
    offset: 0,
    easing: "easeInOutCubic",
  }),

  components: {
    FormType1,
    FormType2,
    FormType3,
    FormType4,
  },

  computed: {
    isForm1() {
      return !this.x.forAnother && !this.x.isNovice;
    },

    isForm2() {
      return !this.x.forAnother && this.x.isNovice;
    },

    isForm3() {
      return this.x.forAnother && !this.x.isNovice;
    },

    isForm4() {
      return this.x.forAnother && this.x.isNovice;
    },

    options() {
      return {
        duration: this.duration,
        offset: this.offset,
        easing: this.easing,
      };
    },

    fullName() {
      return (
        "ФИО: " +
        this.x.firstname +
        " " +
        this.x.middlename +
        " " +
        this.x.lastname
      );
    },

    brokerInfo() {
      return (
        this.x.brokerlastname +
        "." +
        this.x.brokerfirstname +
        "." +
        this.x.brokermiddlename
      );
    },

    allApproval() {
      return (
        this.agreeOffer &&
        this.agreeExpiration &&
        this.agreeProcessingPersonalData
      );
    },

    msgFullTimeLesson() {
      return this.x.forAnother
        ? "ЭТОТ ЧЕЛОВЕК ПОСЕЩАЕТ<br>СТУДИЮ ОЧНО"
        : "Я УЖЕ ПОСЕЩАЮ ЗАНЯТИЯ<br>В СТУДИИ ОЧНО";
    },

    msgNewAtLesson() {
      return this.x.forAnother
        ? "ЭТОТ ЧЕЛОВЕК ЕЩЁ<br>НЕ БЫЛ В СТУДИИ"
        : "Я ВПЕРВЫЕ ПРИДУ<br>НА УРОК В СТУДИЮ";
    },

    goodsType() {
      if (this.x.isAbonement) return "абонемент";
      return "сертификат";
    },

    personalLevel() {
      if (this.x.isNovice) return ", впервые в студии";
      return ", уже посещал/а студию";
    },

    intendedForWhom() {
      if (this.x.forAnother) return " для другого";
      return " для себя";
    },

    isCustomAbonement() {
      return this.x.mychoise !== null && this.x.mychoise === "ДРУГОЕ";
    },

    usedSubscription() {
      const s1 = this.x.mychoise ?? "";
      const s2 = this.isCustomAbonement ? this.x.customAbonement ?? "" : "";
      return (s1.length ? ", " + s1 : s1) + (s2.length > 0 ? " : " + s2 : s2);
    },
  },
  methods: {
    goBack() {
      if (this.step > 1) this.step--;
      /*
      if (this.step <= 1) {
        this.x.isAbonement = true;
      }
      if (this.step <= 2) {
        this.x.forAnother = false;
      }
      if (this.step <= 3) {
        this.x.isNovice = false;
      }
      */
    },

    goStart() {
      //this.step = 1;
      location.href = "https://msk-yoga.ru";
    },

    /*
    sendorder() {
      this.requestCompleted = false;
      this.inProgress = true;
      this.result.ok = false;
      this.result.message = "";
      this.step = 5;
      this.$vuetify.goTo("#app", this.options);
      setTimeout(() => {
        this.requestCompleted = true;
        this.inProgress = false;
        this.result.ok = true;
        this.result.message = "Заявка успешно отправлена";
        //this.result.message = "Возникла ошибка при отправлении заявки";
      }, 3000);
    },
    */

    sendorder() {
      var formData = new FormData();
      formData.append("s", JSON.stringify(this.x));
      var rq = document.getElementsByName("__RequestVerificationToken")[0]
        .value;
      formData.append("__RequestVerificationToken", rq);
      let _this = this;
      this.requestCompleted = false;
      this.inProgress = true;
      this.result.ok = false;
      this.result.message = "";
      this.step = 5;
      this.$vuetify.goTo("#app", this.options);

      axios({
        method: "post",
        url: "/Home/SendPayInfo",
        data: formData,
        config: {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      })
        .then((response) => {
          if (response.status === 200 && response.data.Message === "ok") {
            _this.result.ok = true;
            _this.result.message = "Заявка успешно отправлена";
          } else {
            _this.result.ok = false;
            _this.result.message = "Возникла ошибка при отправлении заявки";
          }
        })
        .catch(() => {
          _this.result.ok = false;
          _this.result.message = "Возникла ошибка при отправлении заявки";
          //_this.result.message = e.message;
        })
        .finally(() => {
          _this.requestCompleted = true;
          _this.inProgress = false;
        });
    },
  },
};
</script>
